import { css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { Style } from "../Styles";
import { BaseElement } from "../BaseElement";
import { litIf } from "../LitUtils";
import { formatTemperature } from "../../Format";

/**
 * Display temperature as either Celsius of Fahrenheit depending on user settings
 */
@customElement("ds-temperature")
export class Temperature extends BaseElement {
    static override styles = [
        Style,
        css`
            :host {
                display: block;
            }
        `,
    ];
    @property({ type: Number }) celsius?: number;

    override render() {
        return litIf(
            !!this.celsius,
            () => html`<span>${formatTemperature(this.celsius as number)}</span>`
        );
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-temperature": Temperature;
    }
}
